var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-process"},[_c('ul',{staticClass:"audio-process-list"},_vm._l((_vm.processList),function(p,i){return _c('li',{key:i,class:{
        'process-active': !!p && i > 6,
        'process-active-six': !!p && i <= 6,
        'process-active-five': !!p && i <= 5,
        'process-active-four': !!p && i <= 4,
        'process-active-three': !!p && i <= 3,
        'process-active-two': !!p && i <= 2,
        'process-active-one': !!p && i <= 1,
      }})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }